













// This component is typically used as a dynamic component inside ModalWrapperComponent
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '../TokenUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';

@Component({
  name: 'ResetPasswordFormComponent',
  components: {}
})
export default class ResetPasswordFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public usernameOrEmail: string = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }
  public clearFields() {
    this.usernameOrEmail = null;
  }
  public async onShow(dynamicProps: any) {
    this.clearFields()
    if (dynamicProps && dynamicProps.usernameOrEmail) this.usernameOrEmail = dynamicProps.usernameOrEmail
  }
  public async onOK() {

    // tidy up form fields
    if (this.usernameOrEmail) this.usernameOrEmail = this.usernameOrEmail.trim()

    // validate form fields
    let abort: boolean = false
    if (!this.usernameOrEmail || this.usernameOrEmail.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter an email address')
    }

    if (abort) return

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/auth/forgotPassword'
      const response: any = await utils.makePostCall(url, { usernameOrEmail: this.usernameOrEmail } );
      if (!response || !response.data) throw(new Error('ForgotPasswordFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user) {
        // success
        this.$store.commit('setLoading', { loading: false });
        this.$emit('close', true)

        // clear out in case they do another
        this.clearFields()

        const user: TokenUser = new TokenUser(response.data.user)
        globalUC.add(user)      // might as well give cache the very latest one

        utils.toast(this, 'Success', 'Check your email for a link to resetting your password.')
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not process')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)
  }
  
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
